export default "__VITE_ASSET__C7r0TU1$__"